import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HTTPService, HelperService, DateService, DataService, FormatService, CalculationService } from 'app/services';
import { find, findIndex, toLower } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { demoEstimateData } from 'app/constants/demo-estimate';

@Component({
  selector: 'app-privacy-policy-template',
  templateUrl: './privacy-policy-template.component.html',
  styleUrls: ['./privacy-policy-template.component.scss']
})
export class PrivacyPolicyTemplateComponent implements OnInit {

  isLoading = true;
  company: any = { address: {} };
  currentLang: string = 'en';
  companyLocalization: boolean = false;
  disclaimerMsg = 'By signing this document, you agree to the Terms and Conditions mentioned below.';
  shopAppSettings: any = {};
  pdfLogoType: string = '';
  customer: any = {};
  disclaimer: string = '';
  invDisclaimer: string = '';

  constructor(private activatedRoute: ActivatedRoute, public helperService: HelperService, private translate: TranslateService,) { }

  ngOnInit() {
    const token = this.activatedRoute.snapshot.paramMap.get('appt_conf_token');
    this.companyLocalization = this.activatedRoute.snapshot.queryParamMap.get('localization') === 'true';

    if (this.companyLocalization) {
      this.currentLang = this.activatedRoute.snapshot.queryParamMap.get('lang');
      this.currentLang = this.helperService.validatePreferredLang(this.currentLang);
      this.currentLang = toLower(this.currentLang);

      // Use the language
      this.translate.setDefaultLang(this.currentLang); // optional fallback
      this.translate.use(this.currentLang); // 🔥 This switches language
    }

    demoEstimateData.company.appsettings.pdfFontSize = Number(token);
    demoEstimateData.company.appsettings.customerPreviewFontSize = Number(token);
    this.setData(demoEstimateData);
  }


  setData(res: any) {
    this.company = res.company || {};

    const shop = res.shop;
    this.shopAppSettings = shop?.appsettings || {};
    const appsettings = this.company?.appsettings;

    if (shop) {
      if (shop.pdfLogo) {
        this.company.logo = shop.pdfLogo;
        this.company.pdfLogo = shop.pdfLogo;
        this.pdfLogoType = shop?.appsettings?.pdfLogoFormatType;
      } else {
        this.company.logo = shop.logo;
        this.company.pdfLogo = shop.pdfLogo;
      }
    } else if (this.company.pdfLogo) {
      this.company.logo = this.company.pdfLogo;
      this.pdfLogoType = appsettings.pdfLogoFormatType;
    }


    this.customer = res.estimate.customer;
    this.disclaimer = res.disclaimer || '';
    this.invDisclaimer = res.invDisclaimer || '';


    if (this.disclaimer) {
      this.disclaimer = this.disclaimer.replace(/\n/g, '<br>');
    }

    if (this.invDisclaimer) {
      this.invDisclaimer = this.invDisclaimer.replace(/\n/g, '<br>');
    }

    this.isLoading = false;
  }

}
